//for that chat id who send whhat message at waht time

const ChatHistory=[
    {sender:"Annie S",chatId:"4",msg:"Hi I am interested in property 1",timestamp:"01010010011"},
    {sender:"Jessie F",chatId:"4",msg:"Okay, Question 1?",timestamp:"01010010012"},
    {sender:"Annie S",chatId:"4",msg:"Answer1...",timestamp:"01010010013"},
    {sender:"Jessie F",chatId:"4",msg:"Okay, Let's escrow property and wait for AGENT to verify",timestamp:"01010010014"},

    
    {sender:"Annie S",chatId:"2",msg:"Hi I am interested in property 2",timestamp:"01010010011"},
    {sender:"Henrey B",chatId:"2",msg:"Hi,Henrey here. Okay, Question 1?",timestamp:"01010010012"},
    {sender:"Annie S",chatId:"2",msg:"Answer1...",timestamp:"01010010013"},
    {sender:"Henrey B",chatId:"2",msg:"Okay, Let's escrow property and wait for AGENT to verify",timestamp:"01010010014"},
];
export default ChatHistory;